import { render } from "./ContentBlocks.vue?vue&type=template&id=13f073f5&scoped=true"
import script from "./ContentBlocks.vue?vue&type=script&lang=js"
export * from "./ContentBlocks.vue?vue&type=script&lang=js"

import "./ContentBlocks.vue?vue&type=style&index=0&id=13f073f5&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f073f5"]])

export default __exports__